import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Form, Input, Select, DatePicker, TimePicker, Button } from "antd";
import { ScheduleBg } from "../utils/Images";
import { schedulecall, setdefaultsubuser } from "../collection/ApiCollection";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import AddReminder from "../components/AddReminder";
import moment from "moment";
import { cousntryCodesArr } from "../utils/constants";
import { reminerData } from "../store/Authentication";

const { Option } = Select;

// Styled Components
const Container = styled.div`
  //   display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-image: url(${ScheduleBg});
  background-size: cover;
  background-position: 50% 50%;
  padding: 30px 0px;

  .main-heading {
    font-weight: 700;
    font-size: 32px;
    color: #fff;
    margin-bottom: 70px;
    text-align: center;

    span {
      color: #0da982;
    }
  }
`;

const FormWrapper = styled.div`
  max-width: 700px;
  width:100%;
  padding: 58px 20px;
  background: #0da98224;
  border: 1px solid #fff;
  border-radius: 18px;
  margin: auto;

  .form{
    color: #fff;
    width: 58%;
    margin:auto;

    @media (max-width: 600px){
      width:78%;
    }
    @media (max-width: 450px){
      width:88%;
    }
  }
`;

const StyledFormItem = styled(Form.Item)`
  margin-bottom: 43px !important;

  input {
    height: 70px;
    border-radius: 12px;
  }
  .ant-picker-input input::placeholder{
    color:#747688 !important;
  }
  .ant-form-item-control-input-content input::placeholder{
    color:#747688 !important;
  }
  .ant-select-selection-placeholder{
    color:#747688 !important;
  }
  .ant-select-selection-search input::placeholder{
  color:#747688 !important;
  }
  .ant-select-selection-placeholder {
    display: flex;
    align-items: center;
  }
  .ant-select-selection-item {
    display: flex;
    align-items: center;
  }
  .ant-select-selector {
    height: 70px !important;
    border-radius: 12px;
  }
  .ant-form-item-label > label {
    color: #fff;
  }
  .btn-div {
    display: flex;
    align-items: center;
    justify-content: center;
    button {
      height: 48px;
      font-weight: 700;
      font-size: 16px;
      padding: 0px 27px;
      color: #fff;
      background-color: #0da982;
      border-radius: 15px;
      border: none;
      margin: auto;
      cursor: pointer;

      &:hover {
        background-color: #0da982;
      }
    }
  }
`;

const ScheduleFirstCall = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const allReminders = useSelector((state) => state?.Authlogin?.reminders);
  console.log(allReminders, "allReminders")
  const [selectedValue, setSelectedValue] = useState(null);
  const [scheduleDate, setScheduleDate] = useState(null);
  const [scheduleTime, setScheduleTime] = useState(null);
  console.log(scheduleDate, "scheduleDate", scheduleTime);
  const [loader, setLoader] = useState(false);
  const [reminders, setReminders] = useState([]);
  const handleDateChange = (date, dateString) => {
    if (date) {
      setScheduleDate(Math.floor(new Date(date).getTime() / 1000));
    } else {
      toast.error("Invalid date selected!");
    }
  };

  const onFinish = async (values) => {
    setLoader(true);
    const scheduleDate = Math.floor(new Date(values.date).getTime() / 1000);
    const scheduleTime = Math.floor(new Date(values.time).getTime() / 1000);
    // const reminderDate = new Date(values.reminder).toISOString();
    const validReminders = reminders?.filter(reminder => reminder && Object.keys(reminder).length > 0) || [];
    const reminderTime = new Date(values.reminder).getTime();
    console.log(values, reminderTime);
    const req = reminders?.length > 0 ? {
      scheduleDate: scheduleDate,
      scheduleTime: scheduleTime,
      receptorName: values?.name,
      receptorAge: values?.age,
      // countryCode: countryCode,
      // phoneNumber: values?.phone,
      agenda: values?.agenda,
      ...(validReminders.length > 0 && { reminders: validReminders })
      // reminders: reminders,
    } : {
      scheduleDate: scheduleDate,
      scheduleTime: scheduleTime,
      receptorName: values?.name,
      receptorAge: values?.age,
      // countryCode: countryCode,
      // phoneNumber: values?.phone,
      agenda: values?.agenda,
    };
    try {
      let res = await schedulecall(req);
      if (res?.status === 200) {
        setLoader(false);
        toast.success(res?.data?.message);
        navigate("/landing/congratulations");
        dispatch(reminerData(validReminders))
      } else {
        setLoader(false);
        toast.error(
          res?.response?.data?.message ||
          res?.error ||
          res?.message ||
          "Something went wrong"
        );
      }
    } catch (error) {
      setLoader(false);
      console.log(error)
      toast.error(
        error?.response?.data?.errors?.[0]?.msg || error?.response?.data?.message ||
        error?.error ||
        error?.message ||
        "Something went wrong"
      );
    }
  };

  const handleTimeSelect = (time, timeString) => {
    if (!scheduleDate) {
      toast.error("Please select a date first!");
      return;
    }

    // Convert UNIX timestamp back to date
    const selectedDate = moment(scheduleDate * 1000).format("YYYY-MM-DD");

    // Combine selected date and time string
    const timeWithDate = `${selectedDate} ${timeString}`;

    // Create a moment object from the combined date and time
    const timestamp = moment(timeWithDate, "YYYY-MM-DD HH:mm").valueOf() / 1000; // Convert to seconds

    // Set the timestamp to state
    setScheduleTime(Math.floor(timestamp)); // Ensure it's an integer
  };

  const options = [
    { value: "Building Connection", label: "Building Connection", description: "Foster companionship and reduce loneliness through meaningful conversations" },
    { value: "Health and Wellness", label: "Health and Wellness", description: "Discuss daily habits and offer support for staying active and health" },
    { value: "Memory Sharing", label: "Memory Sharing", description: "Encourage story telling and recall of past experiences to promote cognitive engagement" },
    { value: "Positive Reflection", label: "Positive Reflection", description: "Boost emotional well-being with uplifting and encouraging discussions" }
  ];

  useEffect(() => {
    if (allReminders?.length > 0) {
      navigate("/landing/congratulations")
    }
  }, [allReminders])


  return (
    <Container>
      <p className="main-heading">
        Let’s schedule your <span>FIRST CALL</span>
      </p>
      <FormWrapper>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          className="form"
          // style={{ color: "#fff", width: "58%", margin: "auto" }}
          requiredMark="optional"
        >
          <StyledFormItem
            name="date"
            label=""
            rules={[{ required: true, message: "Please select a date!" }]}
          >
            <DatePicker
              style={{ width: "100%", height: "70px", borderRadius: "12px" }}
              onChange={handleDateChange}
              disabledDate={(current) => current && current < new Date().setHours(0, 0, 0, 0)}
            />
          </StyledFormItem>

          <StyledFormItem
            name="time"
            label=""
            rules={[{ required: true, message: "Please select a time!" }]}
          >
            <TimePicker
              style={{ width: "100%", height: "70px", borderRadius: "12px" }}
              format="HH:mm"
              onChange={handleTimeSelect}
            />
          </StyledFormItem>

          <StyledFormItem
            name="name"
            label=""
            rules={[{ required: true, message: "Please enter the name!" }]}
          >
            <Input placeholder="Name of Call Receptor" />
          </StyledFormItem>

          <StyledFormItem
            name="age"
            label=""
            rules={[
              { required: true, message: "Please select the age!" },
              {
                pattern: /^[0-9]{1,2}$/, // Ensures only 1 or 2 digit numbers
                message: "Age must be between 0 and 99!",
              },
            ]}
          >
            <Input type="number" placeholder="Age of call Receptor" max={99} min={0} />
          </StyledFormItem>

          <StyledFormItem
            name="agenda"
            label=""
            rules={[{ required: true, message: "Please select the agenda!" }]}
          >

            <Select
              placeholder="Agenda of Call"
              style={{ width: "100%" }}
              value={selectedValue}
              onChange={(value) => setSelectedValue(value)}
              optionLabelProp="label" // This ensures only the 'label' value is shown in the input field
            >
              {options.map((option) => (
                <Option key={option.value} value={option.value} label={option.label}>
                  <div>
                    <p style={{ fontWeight: "600", margin: 0 }}>{option.label}</p>
                    <span style={{ fontSize: "12px", fontWeight: "400", display: "block", whiteSpace: "normal" }}>
                      {option.description}
                    </span>
                  </div>
                </Option>
              ))}
            </Select>
          </StyledFormItem>

          <AddReminder
            scheduleDate={scheduleDate}
            scheduleTime={scheduleTime}
            reminders={reminders}
            setReminders={setReminders}
          />

          <StyledFormItem>
            <div className="btn-div">
              <button type="submit">
                {loader ? "LOADING..." : "SCHEDULE CALL"}
              </button>
            </div>
          </StyledFormItem>
        </Form>
      </FormWrapper>
    </Container>
  );
};

export default ScheduleFirstCall;
